import { useReactiveVar } from '@apollo/client';
import { useIntl } from 'react-intl';
import { FilterButtonProps } from './filter-button.models';
import { filterParams } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { Button } from '../../../../common';
import filterIcon from '../../../../../assets/images/ecp/filter-button.svg';
import { useStyles } from './filter-button.styles';

export const FilterButton = ({ onClick }: FilterButtonProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const currentFilters = useReactiveVar(filterParams);
  const { specializations, shops } = currentFilters;

  const selectedCount = [...specializations, ...shops].filter(Boolean).length;

  const isSelected = selectedCount > 0;

  return (
    <Button
      data-testid="analytics-filter-stores-button" //Don't remove data-testid, it's used by Ya Metrica
      variant="contained"
      onClick={onClick}
      className={classes.buttonSelected}
      startIcon={
        <span className={isSelected ? classes.iconWrapperSelected : classes.iconWrapper}>
          <img
            src={filterIcon}
            alt=""
            className={classes.icon}
          />
        </span>
      }
      endIcon={
        isSelected ? (
          <span
            data-testid="filter-count-badge"
            className={classes.countBadge}
          >
            {selectedCount}
          </span>
        ) : undefined
      }
    >
      {intl.formatMessage({ id: 'ecp.filterButton.label' })}
    </Button>
  );
};
